module.exports = __webpack_public_path__ + "img/1465809397.08914ec1.jpg";